import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VTabs,{attrs:{"value":_vm.dashboardName,"color":"primary"}},_vm._l((_vm.tabs),function(tab){return _c(VTab,{key:tab.name,attrs:{"to":{
        name: 'dashboard',
        params: {
          dashboardName: tab.key === 'default' ? undefined : tab.key,
        },
      },"exact":"true"}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),1),_c('dashboard-component',{attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }